import LoginContainer from './LoginContainer';

export default LoginContainer;



// WEBPACK FOOTER //
// ./assets/app/login/containers/LoginContainer/index.js